export const packageId = 8 as number;
// export const packageId = 2 as number;
export const packageInfo = 'com.resulta.checka';
export const defaultChannel = 'rasi';
export const disabledPhoneCode = true;
export const apiSendPhoneCode = false;
export const defaultPhoneCode = '91';
export const homePage = 'Index';
export const gameNavigateVersion = 1;
